export const environment = {
  version: '1.16',
  build: '',
  defaultLangCode: 'nl',
  uiLanguageForUnsupportedLanguages: 'en',
  debugMessages: {
    TextToSpeechService: false,
  },
  batchHotKeysCount: 20,
  production: false,
  highlight: {
    supportedColors: [
      {
        color: 'yellow',
        tooltip: 'HIGHLIGHT.TOOLTIPS.YELLOW',
        selected: true,
        actualColor: 'rgb(255,255,0)',
        hex: '#FFFF00',
      },
      {
        color: 'orange',
        tooltip: 'HIGHLIGHT.TOOLTIPS.ORANGE',
        selected: true,
        actualColor: 'rgb(243, 146, 0)',
        hex: '#F39200',
      },
      {
        color: 'green',
        tooltip: 'HIGHLIGHT.TOOLTIPS.GREEN',
        selected: true,
        actualColor: 'rgb(45, 171, 41)',
        hex: '#2DAB29',
      },
      {
        color: 'blue',
        tooltip: 'HIGHLIGHT.TOOLTIPS.BLUE',
        selected: true,
        actualColor: 'rgb(146, 218, 255)',
        hex: '#92DAFF',
      },
      {
        color: 'pink',
        tooltip: 'HIGHLIGHT.TOOLTIPS.PINK',
        selected: true,
        actualColor: 'rgb(255, 182, 232)',
        hex: '#FFB6E8',
      },
    ],
  },
  pdfTronLicenceKey: 'Sensotec nv:OEM:Alinea::B+:AMS(20250114):6FB68A13B64C4358C9994E616F7F0DF2D3F14F54453134343ED04AF231F5C7',
  froalaLicenceKey: 'pe1G2wF1C1C4C1B5C6D5E1DpdgdNSWXf1h1MDb1CF1PLPFf1C1EESFKVlA3C11A8A6D2B4H5G2D3J4==',
  colibrioLicenceKey: 'ce0040c4-8133-4ac9-8f70-2415ea3e03b4',
  limits: {
    desktopPaneLimit: 2,
  },
  auth: {
    apiUrl: 'https://cerberusapi-dev.sensotec.be',
    clientId: 'ro.client.cerberus',
    codeClientId: 'ac.client.cerberus',
    AlineaProduct: 'Asgard-Alinea',
    K3000Product: 'Asgard-K3',
    device: 'pc',
    leerIdUrl: 'https://authenticatie-ti.vlaanderen.be/op',
  },
  signalrCom: {
    exam: {
      // signalrHubUrl: 'https://woland.local/exam/consumer',
      // signalrHubUrl: 'https://localhost:5001/exam/consumer',
      signalrHubUrl: 'https://wolandapi-dev.sensotec.be/exam/consumer',
      msgSendMethod: 'PostMessage',
      msgReceiveMethod: 'MessageDelivery',
      broadcastReceiveMethod: 'BroadcastDelivery',
    },
  },
  speech: {
    root: 'https://nephilim-dev.sensotec.be',
    nephilimTTShUrl: 'https://nephilim-dev.sensotec.be/api/v4/texttospeech/text2speech',
    skidbladnirTtsUrl: 'https://skidbladnir-dev.azurewebsites.net/api/v1/texttospeech/text2speech',
    hoverSpeakDelay: 150,
  },
  audioMaker: {
    url: 'https://nephilim-dev.sensotec.be/api/v3/audiomaker/text2audio',
    skidbladnirUrl: 'https://skidbladnir-dev.azurewebsites.net/api/v1/audiomaker/text2audio'
  },
  alinea: {
    drive: {
      clientID: '252738271968-d2r9qa30kv24hukt9dgj39t5s4seojsm.apps.googleusercontent.com',
      scope: [
        'https://www.googleapis.com/auth/drive',
        'email',
      ],
    },
    dropbox: {
      AppKey: 's153vwtuj8zusr2',
    },
    oneDrive: {
      clientId: '195cb9a6-8ccf-4a9c-a544-462a93b034a8',
      scope: [
        'files.readwrite',
        'files.readwrite.all',
        'openid',
        'email',
        'user.read',
      ],
    },
    dodp: {
      dodpProfiles: [
        {
          name: 'DODP Stentor Dev',
          authUrl: 'https://stentorauthsvcdev.azurewebsites.net/oidc/auth',
          tokenUrl: 'https://stentorauthsvcdev.azurewebsites.net/oidc/token',
          contentUrl: 'https://stentordodpsvcdev.azurewebsites.net',
          clientId: 'asgard',
          scope: ['openid']
        }
      ]
    }
  },
  woland: {
    oneDrive: {
      clientId: '24e8722b-c5d9-4494-bada-1a78128e3fbe',
      scope: [
        'files.readwrite',
        'offline_access',
        'files.readwrite.all',
        'openid',
        'email',
        'user.read',
      ],
      redirectUri: 'cloud-connection-redirect/graph-api',
    },
    googleDrive: {
      authUrl: 'https://accounts.google.com/o/oauth2/v2/auth',
      clientId:
        '59412406054-n8k068kind5kbsjq8ssjpq673rp4hrdh.apps.googleusercontent.com',
      scope: [
        'https://www.googleapis.com/auth/userinfo.email',
        'https://www.googleapis.com/auth/drive.file',
      ],
      redirectUri: 'cloud-connection-redirect/google-api',
      responseType: 'code',
    },
  },
  kurzweil: {
    drive: {
      clientID: '926498984818-a8dncr5qeboaub0au9vtjhn4nlcm2s2b.apps.googleusercontent.com',
      scope: [
        'https://www.googleapis.com/auth/drive',
        'email',
      ],
    },
    dropbox: {
      AppKey: 'rzkihcwopjy0wmu',
    },
    oneDrive: {
      clientId: '4a68bd24-43a7-4138-aefa-1bd646f3f03d',
      scope: [
        'files.readwrite',
        'files.readwrite.all',
        'openid',
        'email',
        'user.read',
      ],
    },
  },
  conversions: {
    baseUrl: 'https://huginn-dev.sensotec.be',
    htmlRtfUrl: 'https://huginn-dev.sensotec.be/api/v1/htmlrtfworkitems/',
    kesPdfUrl:
      'https://huginn-dev.sensotec.be/api/v1/kespdfconverterworkitems/',
    imgPdfUrl: 'https://huginn-dev.sensotec.be/api/v1/ocrworkitems/',
    dediconPdfUrl: 'https://huginn-dev.sensotec.be/api/v1/dediconpdf/',
  },
  connectedApiUrls: {
    cerberus: 'https://cerberusapi-dev.sensotec.be',
    huginn: 'https://huginn-dev.sensotec.be',
    dictionaryApi: 'https://huginndict-dev.sensotec.be',
    nephilim: 'https://nephilim-dev.sensotec.be',
    // woland: 'https://woland.local',
    // woland: 'https://localhost:5001',
    woland: 'https://wolandapi-dev.sensotec.be',
  },
  apiVersions: {
    cerberus: 'api/v1',
    huginn: 'api/v1',
    dictionaryApi: 'api/v1',
    nephilim: 'api/v1',
    woland: 'api/v1',
  },
  sti: {
    name: 'STI',
    clientId_alinea: '3930bd0335bd2a91fb498baa809dd7ed',
    clientId_kurzweil: '7e503d9199d654073081316c1d18691a',
    baseUrl: 'https://mijnboekenkluis.nl/staging/',
  },
  settingsFileName: 'AsgardAlineaSettings',
  spellCheck: {
    supportedLangCodes: ['en', 'nl', 'fr', 'de'],
  },
  wordPrediction: {
    supportedLangCodes: ['en', 'nl', 'fr', 'de'],
  },
  externalRedirectReferrers: [
    {
      link: 'https://alinea.lexipoort.nl',
      params: {
        loginLogoPath: '../../../assets/images/lexima.svg',
      },
    },
    {
      link: 'https://kurzweil.lexipoort.nl',
      params: {
        loginLogoPath: '../../../assets/images/lexima.svg',
      },
    },
  ],
  manualUrl: 'https://download.lexima.nl/Documentatie/Examode/examode.html',
};
